module.exports = __webpack_public_path__ + "img/th_th2.f973b3fa.png";